import React from "react";

const OnboardSummary = ({
  width = 88,
  height = 88,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="87"
        height="87"
        rx="43.5"
        fill="url(#paint0_linear_1050_35356)"
      />
      <rect
        x="0.5"
        y="0.5"
        width="87"
        height="87"
        rx="43.5"
        stroke="url(#paint1_linear_1050_35356)"
      />
      <g filter="url(#filter0_d_1050_35356)">
        <rect x="16" y="16" width="56" height="56" rx="28" fill="white" />
        <rect
          x="16.5"
          y="16.5"
          width="55"
          height="55"
          rx="27.5"
          stroke="#E2E4E9"
        />
        <path
          d="M41.9 47.3323L51.5516 37.6797L53.0373 39.1644L41.9 50.3017L35.2178 43.6195L36.7025 42.1348L41.9 47.3323Z"
          fill="#525866"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1050_35356"
          x="12"
          y="14"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1050_35356"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1050_35356"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1050_35356"
          x1="44"
          y1="0"
          x2="44"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E5E7" stopOpacity="0.48" />
          <stop offset="1" stopColor="#F7F8F8" stopOpacity="0" />
          <stop offset="1" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1050_35356"
          x1="44"
          y1="0"
          x2="44"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E5E7" />
          <stop offset="0.765625" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default OnboardSummary;
